<a
    class="flex items-center justify-center btn btn-toggle md:text-base"
    [ngClass]="{
        'btn-toggle-active': isActive,
        'text-secondary-700': !isActive,
        'opacity-50 pointer-events-none': isDisabled
    }"
    [routerLink]="['./']"
    [replaceUrl]="true"
    [queryParams]="isDisabled ? {} : { facets: toggleFacetValueIds(), p: 1 }"
    [queryParamsHandling]="'merge'"
    [state]='{ noScroll: true }'
>
    <fa-icon
        class="mr-2"
        [ngClass]="{ 'text-secondary-600': !isActive, 'text-white': isActive }"
        [icon]="check"
        size="1x"
    ></fa-icon>
    <span>{{ preset.title }}</span>
</a>
